import React, { useState } from 'react'
import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Button, Drawer, Dropdown, Form, Input } from 'antd'
import { handleConfirm, handleTableSelect } from '../../../context/utils'
import CustomTable from '../../../components/CustomTable'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
import { BiEdit } from 'react-icons/bi'
import { GoTrash } from 'react-icons/go'
import { useDeleteFaq, useGetFaqs, usePatchFaq, usePostFaq } from '../../../hooks/faq/faq'

function FaqsManagementPage() {
  const [createPayload, setCreatePayload] = useState({
    title:"",
    content:"",
  })
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [isOpenEdit, setIsOpenEdit] = useState(false)

  const onCreateOpen = () => setIsCreateOpen(true)
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()

  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setIsOpenEdit(false)
    setRows([])
  }
  
  const {
    data: getData,
    refetch: getFetch,
    isFetching: getLoad,
  } = useGetFaqs()

  const successAction = () => {
    getFetch()
    form.resetFields();
    onCreateClose()
  };

  const {
    mutate: postAction,
    isLoading: postLoad,
  } = usePostFaq(successAction)

  const {
    mutate: deleteAction,
    isLoading: deleteLoad,
  } = useDeleteFaq(successAction)

  const {
    mutate: putAction,
    isLoading: putLoad,
  } = usePatchFaq(successAction)

  const handleEdit = (d) => {
      setIsOpenEdit(true)
      setCreatePayload({
        title:d?.title,
        content:d?.content,
        id:d?.id
      })
  }

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key:"1",
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{e}</p>
    },
    {
      title: "Content",
      dataIndex: "content",
      key:'2',
      render: (e) => 
        <p className='text-sm font-medium text-dim'>{e}</p>
    },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft"
        menu={{items: [
          // {key: "view", icon: <SlEye className='!text-base' />, label: <button id=''>View</button>},
          {key: "edit", label: <button className='flex' id='' onClick={()=>handleEdit(data)}> <BiEdit className='!text-base mx-2 py-auto' /> Edit</button>},
          {key: "delete", label: <button className='flex' onClick={() => handleConfirm({data: data?.id, action: deleteAction})}><GoTrash className='!text-base mx-2 py-auto'  /> Delete</button>},

        ]}}
      >
        <Button className='!bg-[#F2F6FC]' loading={deleteLoad} type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]

  const onSubmit = (d) => {
    postAction(d)
  }
  const onSubmitEdit = () => {
    putAction(createPayload)
  }

  return (
    <PadContainer loading={getLoad}>
      <TitleContainer
        path={false}
        title="FAQs Management"
        className="border border-lit rounded-xl"
        action={<Button onClick={onCreateOpen} className='!bg-light_blue' type='primary' size='large' icon={<FaPlus />}>Add FAQs</Button>}
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getData?.data?.data || []}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
      </TitleContainer>


      {/* create create drawer */}
      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>New FAQ</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <Form.Item label="Title" name="title">
            <Input size='large' placeholder='' />
          </Form.Item>
          <Form.Item label="Content" name="content">
            <Input.TextArea placeholder='Enter description' size='large' rows={4} />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={postLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      {/* create edit drawer */}
      <Drawer
        open={isOpenEdit}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit FAQ</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
        >
          <Form.Item label="Title">
            <Input 
                size='large' 
                placeholder='' 
                value={createPayload.title}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, title: value})}
            />
          </Form.Item>
          <Form.Item label="Content">
            <Input.TextArea 
                placeholder='Enter content' 
                size='large' rows={4} 
                value={createPayload.content}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, content: value})}
            />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={putLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>
    </PadContainer>
  )
}

export default FaqsManagementPage